import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { fetchDepartments } from "../../redux/actions/departmentActions";
import { addStaff } from "../../redux/actions/staffActions";
import { FiUpload } from "react-icons/fi";
import { LuUserCheck } from "react-icons/lu";
import { TbLayout2, TbUsers } from "react-icons/tb";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageComponent from "../../Components/PageComponent";

function AcademicStaff() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: departments = [], loading, error } = useSelector((state) => state.department.department);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const formats = ["font", "header", "bold", "italic", "underline", "align"];

  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    email: "",
    qualifications: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    dispatch(fetchDepartments());
  }, [dispatch]);

  const handleDepartmentChange = (id) => {
    setSelectedDepartmentId(id);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
      setFormData((prev) => ({ ...prev, image: file }));
    }
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!selectedDepartmentId) {
      alert("Please select a department.");
      return;
    }

    // Validation for required fields
  if (!formData.name.trim()) {
    alert("Name is required.");
    return;
  }
  if (!formData.designation.trim()) {
    alert("Designation is required.");
    return;
  }
  if (!formData.email.trim()) {
    alert("Email is required.");
    return;
  }
  const plainMessage = stripHtml(formData.qualifications);

      if (!plainMessage.trim()) {
        alert("Qualifications cannot be empty.");
        return;
      }
      if (!formData.image) {
        alert("An image is required.");
        return;
      }
    
  
    const formPayload = new FormData();
    formPayload.append("name", formData.name);
    formPayload.append("designation", formData.designation);
    formPayload.append("email", formData.email);
    formPayload.append("qualifications", formData.qualifications);
    formPayload.append("department", selectedDepartmentId); // Send department ID instead of name
    if (formData.image) {
      formPayload.append("file", formData.image);
    }
  
    try {
      await dispatch(addStaff(formPayload)); // Dispatch the action
      alert("Staff member added successfully!");
      window.location.reload(); // Refresh the page
    } catch (err) {
      console.error("Error adding staff member:", err);
      alert("An error occurred while adding the staff member.");
    }
  };
  
  return (
     <>
        <PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">Department Management</span>
        </div>

         {/* Buttons */}
         <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/academics&international/departmentManagement/department")}
          >
            <TbLayout2 className="mr-2" />
            Department
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/academics&international/departmentManagement/leadershipMessages")}
          >
            <LuUserCheck className="mr-2" />
            Leadership Messages
          </button>
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() => navigate("/academics&international/departmentManagement/academicStaff")}
          >
            <TbUsers className="mr-2" />
            Academic Staff
          </button>
           <button className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                    onClick={() => navigate("/academics&international/departmentManagement/allStaff")}>
                      <TbUsers className="mr-2" />
                      All Staff
                    </button>
        </div>

        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">Select Department</h2>
          {loading ? (
            <p>Loading departments...</p>
          ) : error ? (
            <p className="text-red-500">Error: {error}</p>
          ) : (
            <select
              className="w-1/2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
              onChange={(e) => handleDepartmentChange(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                Select a Department
              </option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.department_name}
                </option>
              ))}
            </select>
          )}
        </div>

        {selectedDepartmentId && (
          <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
            <form onSubmit={handleSave}>
              <h2 className="mb-4 text-xl font-semibold text-gray-700">Add Academic Staff</h2>
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="name">
                    Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="designation">
                    Designation
                  </label>
                  <input
                    id="designation"
                    name="designation"
                    type="text"
                    value={formData.designation}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="email">
                    Contact Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 mb-4">
                <div className="relative flex flex-col items-center justify-center w-full h-[225px] p-5 border border-gray-300 border-dashed rounded-md">
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="absolute inset-0 object-cover w-full h-full opacity-50"
                    />
                  ) : (
                    <>
                      <FiUpload className="w-10 h-10 p-2 mb-3 text-gray-400 bg-gray-100 border-none rounded-md" />
                      <p className="text-black">Drag and drop image here</p>
                      <p className="text-sm text-center text-gray-400">
                        {/* Any size of image, will automatically adjust to the frame  */}
                        Image size should 300 px x 250 px (width x height)
                        </p>
                    </>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                    className="hidden"
                    id="file-upload"
                  />
                  <label
                    htmlFor="file-upload"
                    className="px-4 py-2 mt-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md cursor-pointer z-10"
                  >
                    Browse Image
                  </label>
                </div>
                <div className="col-span-2">
                  <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="qualifications">
                    Qualifications
                  </label>
                  <ReactQuill
                    id="qualifications"
                    value={formData.qualifications}
                    onChange={(value) => setFormData((prev) => ({ ...prev, qualifications: value }))}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    className="h-[160px]"
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
    </PageComponent>
    </>
  );
}

export default AcademicStaff;
